export const initialState = {
    isLoading: false,
    assessmentTrigger: false,
    header: {},
    footer: {},
    home: {},
    riskFall: {},
    assessmentLanding: {},
    riskScoreData: {},
    bundleLayout: {},
    bundleList: {},
    bundleDetail: {},
    alertMessage: { isOpen: false, alertData: {} },
    productDetailData: {},
    zipCodeIsValid: {},
    cartListData: [],
    cartAlert: { isOpen: false, alertData: {} },
    emailPopup: { isOpen: false, emailData: {} },
    zipCodePopup: {
        isOpen: false, zipCodeData: {
            installation: false,
            fall_prevention: false,
            zipCode: "",
        }
    },
    helpingPopup: { isOpen: false, data: {} },
    checkoutData: {},
    checkoutOrderSummary: {},
    checkoutPayment: {},
    countryList: [],
    stateList: [],
    stateListBilling: [],
    paymentStatus: {},
    billingResponseData: {},
    shippingMethod: {},
    servicePopup: { isOpen: false, data: null, apiData: "" }


};


const reducer = (state, action) => {
    switch (action.type) {
        case "SET_IS_LOADING":
            return {
                ...state,
                isLoading: action.value,
            };
        case "SET_IS_HELPING":
            return {
                ...state,
                helpingPopup: { isOpen: action.value, data: action.data },
            };
        case "SET_HEADER":
            return {
                ...state,
                header: action.data,
            };
        case "SET_FOOTER":
            return {
                ...state,
                footer: action.data,
            };
        case "SET_HOME":
            return {
                ...state,
                home: action.data,
            };
        case "SET_RISKFALL":
            return {
                ...state,
                riskFall: action.data,
            };
        case "SET_ASSESSMENT_LANDING":
            return {
                ...state,
                assessmentLanding: action.data,
            };
        case "SET_RISKSCORE":
            return {
                ...state,
                riskScoreData: action.data,
            };
        case "SET_BUNDLE_LAYOUT":
            return {
                ...state,
                bundleLayout: action.data,
            };
        case "SET_BUNDLE_LIST":
            return {
                ...state,
                bundleList: action.data,
            };
        case "SET_BUNDLE_DETAIL":
            return {
                ...state,
                bundleDetail: action.data,
            };
        case "SET_ALERT_MESSAGE":
            return {
                ...state,
                alertMessage: { isOpen: action.value, alertData: action.data },
            };
        case "SET_IS_ZIPCODE_VALID":
            return {
                ...state,
                zipCodeIsValid: action.data,
            };
        case "SET_CARTLIST_DATA":
            return {
                ...state,
                cartListData: action.data,
            };
        case "SET_PRODUCT_DETAILS":
            return {
                ...state,
                productDetailData: action.data,
            };
        case "SET_CART_ALERT":
            return {
                ...state,
                cartAlert: { isOpen: action.value, alertData: action.data },
            };
        case "SET_EMAIL_POPUP":
            return {
                ...state,
                emailPopup: { isOpen: action.value, emailData: action.data },
            };
        case "SET_ZIP_CODE_POPUP":
            return {
                ...state,
                zipCodePopup: { isOpen: action.value, zipCodeData: action.data },
            };
        case "SET_CHECKOUT_DATA":
            return {
                ...state,
                checkoutData: action.data,
            };
        case "SET_CHECKOUT_ORDER_SUMMARY":
            return {
                ...state,
                checkoutOrderSummary: action.data,
            };
        case "SET_CHECKOUT_PAYMENT":
            return {
                ...state,
                checkoutPayment: action.data,
            };
        case "SET_CHECKOUT_COUNTRY":
            return {
                ...state,
                countryList: action.data,
            };
        case "SET_CHECKOUT_STATE":
            return {
                ...state,
                stateList: action.data,
            };
        case "SET_CHECKOUT_BILLING_STATE":
            return {
                ...state,
                stateListBilling: action.data,
            };
        case "SET_CHECKOUT_PAYMENT_STATUS":
            return {
                ...state,
                paymentStatus: action.data,
            };
        case "SET_CHECKOUT_BILLING_DATA":
            return {
                ...state,
                billingResponseData: action.data,
            };
        case "SET_CHECKOUT_SHIPPING_METHOD":
            return {
                ...state,
                shippingMethod: action.data,
            };
        case "SET_IS_SERVICE_POPUP":
            return {
                ...state,
                servicePopup: { isOpen: action.value, data: action.data, apiData: action.apiData },
            };
        default:
            return state;
    }
};
export default reducer;

